import { calcSensorHex } from '@helpers/helper';

import type { IActionItem } from '@model/actionItem';
import type { IInstallationPoint } from '@model/installationPoint';

import type { IAiControls } from '../model/IAiControls';

export const getEquipmentHexSerial = (
  typeName: string,
  point: IInstallationPoint,
  actionItem: IActionItem,
  controls: IAiControls,
) => {
  if (controls.isOnboardingMockupAi) {
    return 'A267B1';
  }

  if (typeName === 'tachometer') return (point?.sensor_id && point?.sensor_id.toString()) || '---';
  if (controls?.isSensor || controls?.isMote)
    return calcSensorHex(point?.sensor?.hardware_id, point?.sensor_id || actionItem?.sensor_id);

  return actionItem?.serial?.toString() || '';
};
